export default __webpack_public_path__ + "static/media/Acolyte's Armbands of the Spilling Blood.68d1a69a.jpg";